import View from './View';

export { default as View } from './View';
export { getNavBarMenuStyles } from './styles';

export default View;
